<div class="flex items-center justify-between">
  <div class="flex items-center">
    <mat-icon svgIcon="assignment" class="mr-8"></mat-icon>
    <div class="mat-subtitle-2 mb-0 fs-24 fw-600">{{'INSTANCE_DETAILS.RUNBOOK' | transloco}} 
      @if (showRunbook) {
        <span>({{searchTerm?.length > 0 && searchedResult ? searchedResult.length || 0 : (data?.length || 0)}})</span>
      }
    </div>
    @if (showRunbook) {
      <div class="ml-16 search-runbook">
        <app-search-filter [ngClass]="{'disabled': !runbookResponse || runbookLoading}" class="mt-20 ml-20" placeholder="SEARCH.SEARCH" (changed)="search($event)"></app-search-filter>
      </div>
      <span class="vertical-dash ml-12"></span>
      <button [ngClass]="{'disabled': !runbookResponse || runbookLoading}" class="flex justify-center items-center context-menu-icon-filter height menu-btn pr-8 pl-8 pt-6 pb-6 ml-12 filter" (click)="filterColumns()">
        <mat-icon svgIcon="filter_alt" class="mr-4"></mat-icon>
        <span class="fw-500 filters">{{'TENANT_LIST.FILTERS' | transloco}}</span>
      </button>
    }
  </div>
  @if (showRunbook && runbook?.length > 0) {
    <div class="flex flex-row gap-3 create-runbook">
      @if (isCreateAllowed) {
        <button type="submit" class="flex accent h-32 mt-16 mr-8" (click)="disableCreate || deployStatus ? '' : createClick()" [ngClass]="{'disabled': disableCreate || deployStatus}">
          <mat-icon svgIcon="add" class="mr-6 mt-6 icon-sm"></mat-icon>{{'BUTTONS.CREATE' | transloco}}
        </button>
        <div class="flex items-center border-left mr-4"></div>
      }
    <div class="refresh-circle rounded-full w-32 h-32 flex items-center justify-center cursor-pointer" (click)="refreshClick()">
      <mat-icon svgIcon="refresh" class="icons transition-transform duration-700" [ngClass]="{ 'animate-spin': isRefreshing }"></mat-icon>
    </div> 
    <app-environment-paginator [length]="searchedResult?.length" [pageIndex]="pageIndex" [pageSize]="paginationSize" (page)="onPageChange($event)" class="env-paginator"></app-environment-paginator>
    </div>
  }
</div>
<div *ngIf="selectedType?.length > 0 || selectedStatus?.length > 0 || selectedVersion?.length > 0 || filterStartDate && filterEndDate" class="flex flex-row items-center ml-8">
      @if (selectedType?.length > 0) {
        <span class="pr-8 fs-16">{{ 'TOOLBAR.TYPE' | transloco }}</span>
      }
      <div class="mr-4 filtered-items flex items-center fs-16 fw-500" *ngIf="selectedType?.length > 0">
               <span *ngFor="let type of selectedType" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-2 pb-2 mr-16">
                  {{getTypeLabel(type) | titlecase}}
                  <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelTypeFilter(type)"></mat-icon>
               </span>
         </div>
          @if (selectedStatus?.length > 0) {
            <span class="pr-8 fs-16">{{ 'TOOLBAR.STATUS' | transloco }}</span>
          }
         <div class="mr-4 filtered-items flex items-center fs-16 fw-500" *ngIf="selectedStatus?.length > 0">
               <span *ngFor="let status of selectedStatus" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-2 pb-2 mr-16">
                  {{getStatusLabel(status) | titlecase}}
                  <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelStatusFilter(status)"></mat-icon>
               </span>
         </div>
          @if (selectedVersion?.length > 0) {
            <span class="pr-8 fs-16">{{ 'TOOLBAR.VERSION' | transloco }}</span>
          }
         <div class="mr-4 filtered-items flex items-center fs-16 fw-500" *ngIf="selectedVersion?.length > 0">
               <span *ngFor="let version of selectedVersion" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-2 pb-2 mr-16">
                  {{getVersionLabel(version)}}
                  <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelVersionFilter(version)"></mat-icon>
               </span>
         </div>
          @if (filterStartDate && filterEndDate) {
           <span class="pr-8 fs-16">{{ 'SCHEDULE_DETAILS.MODIFIED_DATE' | transloco }}:</span>
          }
         <div class="mr-4 filtered-items flex items-center fs-16 fw-500" *ngIf="filterStartDate && filterEndDate">
            <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-2 pb-2 mr-16">
               {{ datePipe.transform(filterStartDate, 'dd MMM yyyy') }} - {{ datePipe.transform(filterEndDate, 'dd MMM yyyy') }}
               <span class="ml-8">
               <mat-icon svgIcon="close" class="cursor-pointer icon-sm" (click)="canceRunbookDateFilter()"></mat-icon>
               </span>
            </span>
         </div>
         <div class="flex flex-row items-center">
            <span *ngIf="selectedStatus?.length > 0 || selectedType?.length > 0 || selectedVersion?.length > 0 || (filterStartDate && filterEndDate)" class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg" (click)="resetRunbookFilter()">
               {{ 'BUTTONS.CLEAR_ALL' | transloco }}
            </span>
         </div>
      </div>
<mat-divider class="neutral-2 mt-12 mb-12 ml-4 mr-4"></mat-divider>
@if (runbookResponse && !showLoader) {
<div class="flex flex-col border-radius route-table mb-16 mt-8 envt-runbook">
  <app-environment-table class="runbook-table" [ngClass]="{'disabled': showLoader}" (searchedResults)="searchedItems($event)" [displayColumns]="displayColumns" [showSkeletonLoader]="runbookLoading" [instance]="instance" [initialDataSource]="data" [dataLoading]="runbookLoading" [searchTerm]="searchTerm" [dataSourceLength]="showRunbook" [initialCreate]="runbook?.length === 0" (sorted)="resetPaginator()" (pageModify)="onTablePageChanged($event)" (pageChanged)="onPageChange($event)" pageName="runbook" (redeploy)="redeployClick($event)" (deleteRunbookEmit)="fetchRunbook()" (updateRunbookEmit)="fetchRunbook()"></app-environment-table>
</div>
}
@if (!runbookResponse && !apiNotFound && !showLoader && showRunbook && !runbook?.length) {
<div class="flex flex-col" >
  <div class="flex flex-col empty-panel ml-10 mr-16 mt-16">
    <div class="empty-data flex flex-col items-center mt-32 ">
      <img class="w-106" alt="runbook not found" src="/assets/images/service_not_found.png">
      <div class="flex mt-6 ">{{'RUNBOOK.NO_RUNBOOK' | transloco }}</div>
    </div>
    @if (isCreateAllowed) {
    <div class="flex justify-center mt-24">
      <button  type="button" class="flex accent justify-center items-center mat-subtitle-2" mat-button
        (click)="disableCreate ? '' : createClick()" [ngClass]="{'disabled': disableCreate}">
        <mat-icon svgIcon="add" class="icon-md-2"></mat-icon>
        {{'BUTTONS.CREATE' | transloco }}
      </button>
    </div>
    }
  </div>
</div>
}
@if (!showRunbook && isDataLoaded){
   <div class="pt-38 unauth-container pb-50 mb--20">
    <img class="image" src="/assets/images/unauthorized.svg">
    <div class="fw-600 fs-20 mat-subtitle-2 mt-32"> {{ 'UNAUTHORIZED.MESSAGE' | transloco }}</div>
  </div>
}
@if (showLoader && runbookLoading) {
<div class="loader-section">
  <div class="runbook-group loader-header flex flex-col p-16">
    <div class="flex flex-row">
      @for (tableColumn of displayColumns; track tableColumn?.key) {
        <div class="loader-style">
          <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
        </div>
      }
    </div>
  </div>

  @for (item of [1, 2, 3]; track $index) {
    <div class="w-100-percent">
    <div class="runbook-group flex flex-col p-16">
      <div class="flex flex-row">
        @for (tableColumn of displayColumns; track tableColumn?.key) {
          <div class="loader-style">
            <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        }
      </div>
    </div>
    </div>
  }
</div>
}
